import { FC, useState } from 'react';
import { CustomButton, CustomModal } from 'components';
import { ButtonType } from 'components/custom-button/CustomButton';
import { CircleCloseIcon } from 'assets/icons';
import { VoidFn } from 'types/baseTypes';
import { PushScheduleBy } from '../constant';

interface PushByCustomTimeModalProps {
  isOpen: boolean;
  onClose: VoidFn;
  onUpdate: (value: number, unit: PushScheduleBy) => void;
  isLoading?: boolean;
}

const PushByCustomTimeModal: FC<PushByCustomTimeModalProps> = ({ isOpen, onClose, onUpdate, isLoading = false }) => {
  const [value, setValue] = useState<number>(1);
  const [unit, setUnit] = useState<PushScheduleBy>(PushScheduleBy.DAY);

  const handleUpdate = () => {
    if (value > 0) {
      onUpdate(value, unit);
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    if (inputValue === '') {
      setValue(0);
    } else {
      const numValue = parseInt(inputValue);
      if (!isNaN(numValue) && numValue >= 0) {
        setValue(numValue);
      }
    }
  };

  if (!isOpen) return null;

  return (
    <CustomModal open={isOpen} width="md:w-[363px]" height="md:h-[263px]" className="overflow-visible">
      <div className="flex grow flex-col px-6">
        <div className="flex items-center justify-between py-6">
          <div className="text-xl font-bold text-headingGray">Push by custom</div>
          <CircleCloseIcon onClick={onClose} className="shrink-0 cursor-pointer" />
        </div>

        <div className="flex flex-col gap-2">
          <div className="text-17px font-semibold text-primaryText">Push by</div>

          <div className="flex items-center gap-4">
            <input
              id="push-by-custom-time-input"
              type="number"
              value={value === 0 ? '' : value}
              onChange={handleInputChange}
              className="h-12 w-[141px] rounded-md bg-secondaryBtn px-3
               py-2 text-left text-sbase font-medium
               text-primaryText outline-none"
            />

            <div className="flex h-12 rounded-md bg-secondaryBtn p-2">
              <button
                type="button"
                onClick={() => setUnit(PushScheduleBy.DAY)}
                className={`px-4 py-[5.5px] text-sbase font-semibold transition-colors ${
                  unit === PushScheduleBy.DAY ? 'bg-primary text-secondary' : 'bg-transparent text-accentText'
                } rounded-md`}>
                Days
              </button>
              <button
                type="button"
                onClick={() => setUnit(PushScheduleBy.HOUR)}
                className={`px-4 py-[5.5px] text-sbase font-semibold transition-colors ${
                  unit === PushScheduleBy.HOUR ? 'bg-primary text-secondary' : 'bg-transparent text-accentText'
                } rounded-md`}>
                Hours
              </button>
            </div>
          </div>
        </div>

        <div className="mt-8 flex justify-end gap-4">
          <CustomButton
            id="push-custom-time-cancel-button"
            type={ButtonType.SECONDARY}
            onClick={onClose}
            className="w-[100px]">
            Cancel
          </CustomButton>
          <CustomButton
            id="push-custom-time-update-button"
            type={ButtonType.PRIMARY}
            onClick={handleUpdate}
            disabled={value <= 0 || isLoading}
            isLoading={isLoading}
            className="w-[100px]">
            Update
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
};

export default PushByCustomTimeModal;
